import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import AddEditBOM from "./AddEditBOM";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import Button from "../2/Controls/Button";
import ExportButton from "../2/Controls/ExportButton";
import ImportData from "../ImportData";
import ImportLog from "../ImportLog";
import { exportFile } from "../../actions/DataExporter";

class BomList extends Component {

    constructor(props) {

        super(props);

        this.state = {

            list: [],
            totalCount: 0,
            loading: false,

            page: 1,
            pageSize: 25,

            filter: {
                searchText: "",
                product: "",
                sku: "",
                status: "active"
            },

            showAddBOM: false,
            selectedRow: null,

            showFilter: false,
            showOption: false,
            showDelete: false,

            showImport: false,
            showImportLog: false,

            isFilterActive: false,

            exportMessage: "",

            listPageSettings: {

                Title: "BOM",

                Search: {

                    showSearch: true,
                    placeholder: "Search BOM / Product",
                    onSearch: this.onSearch,
                    onRefresh: this.onRefresh,
                    onFilterClick: () => this.setState({ showFilter: true }),
                    isFilterActive: false

                },

                HeaderButtons: [

                    {
                        ButtonType: "Button",
                        Type: "primary",
                        Text: "New",
                        Icon: "add",
                        Action: "popup"
                    },

                    {
                        ButtonType: "ImageButton",
                        Type: "option",
                        Text: "Options",
                        Icon: "option",
                        Action: "options"
                    }

                ],

                Columns: [

                    {
                        Name: "Product SKU",
                        Type: "field",
                        Columns: [{ Column: "Product.SKU" }]
                    },

                    {
                        Name: "Product Name",
                        Type: "field",
                        Columns: [{ Column: "Product.Name" }]
                    },

                    {
                        Name: "",
                        Type: "multiple",
                        ShowInMobile: true,
                        Columns: [

                            { Column: "Product.SKU" },
                            { Column: "Product.Name" }

                        ]

                    }

                ],

                RowButtons: [

                    {
                        ButtonType: "ImageButton",
                        Type: "edit",
                        Icon: "edit",
                        Action: "popup"
                    },

                    {
                        ButtonType: "ImageButton",
                        Type: "delete",
                        Icon: "delete",
                        Action: "delete"
                    }

                ]

            }

        };

    }

    componentDidMount() {

        this.loadData();

    }

    /* ------------------ LOAD DATA ------------------ */

    loadData = async () => {

        this.setState({ loading: true });

        const res = await this.props.getBOMList(

            this.state.filter.searchText,
            this.state.filter.product,
            this.state.filter.sku,
            this.state.filter.status

        );

        this.setState({

            list: res.searchResult || [],
            totalCount: res.totalCount || 0,
            loading: false

        });

    };

    /* ------------------ SEARCH ------------------ */

    onSearch = (text) => {

        this.setState({

            filter: {

                ...this.state.filter,
                searchText: text

            },

            page: 1

        }, this.loadData);

    };

    
    onRefresh = (text) => {

        this.setState({

            filter: {

                   searchText: "",
                product: "",
                sku: "",
                status: "active"


            },
            isFilterActive: false,

            page: 1

        }, this.loadData);

    };

    /* ------------------ FILTER ------------------ */

    onApplyFilter = () => {

        this.setState({

            isFilterActive: true,
            showFilter: false,
            page: 1

        }, this.loadData);

    };

    onClearFilter = () => {

        this.setState({

            filter: {

                searchText: "",
                product: "",
                sku: "",
                status: "active"

            },

            isFilterActive: false,
            showFilter: false,
            page: 1

        }, this.loadData);

    };

    /* ------------------ HEADER BUTTON ------------------ */

    onHeaderButtonClicked = (btn) => {

        if (btn.Action === "popup") {

            this.setState({

                showAddBOM: true,
                selectedRow: null

            });

        }

        if (btn.Action === "options") {

            this.setState({

                showOption: true

            });

        }

    };

    /* ------------------ ROW BUTTON ------------------ */

    onRowButtonClicked = (btn, row) => {

        if (btn.Action === "popup") {

            this.setState({

                showAddBOM: true,
                selectedRow: row

            });

        }

        if (btn.Action === "delete") {

            this.setState({

                showDelete: true,
                selectedRow: row

            });

        }

    };

    /* ------------------ DELETE ------------------ */

    deleteRecord = async () => {

        await this.props.deleteBOMs(

            this.state.selectedRow.key

        );

        this.setState({

            showDelete: false,
            selectedRow: null

        }, this.loadData);

    };

    /* ------------------ EXPORT ------------------ */

    handleExport = async (type) => {

        try {

            const res = await this.props.getBOMList(

                this.state.filter.searchText,
                this.state.filter.product,
                this.state.filter.sku,
                this.state.filter.status

            );

            let data = [];

            if (
                res &&
                res.hasOwnProperty("searchResult") &&
                Array.isArray(res.searchResult)
            ) {

                data = res.searchResult;

            }

            let exportList = [];

            for (let i = 0; i < data.length; i++) {

                let obj = data[i];

                if (
                    obj &&
                    obj.hasOwnProperty("RawMaterials") &&
                    Array.isArray(obj.RawMaterials)
                ) {

                    for (let k = 0; k < obj.RawMaterials.length; k++) {

                        let record = {};

                        if (k === 0) {

                            record = {

                                BOMName:
                                    obj.hasOwnProperty("BOMName")
                                        ? obj.BOMName
                                        : "",

                                ProductSKU:
                                    obj.hasOwnProperty("Product") &&
                                        obj.Product &&
                                        obj.Product.hasOwnProperty("SKU")
                                        ? obj.Product.SKU
                                        : "",

                                ProductName:
                                    obj.hasOwnProperty("Product") &&
                                        obj.Product &&
                                        obj.Product.hasOwnProperty("Name")
                                        ? obj.Product.Name
                                        : "",

                                RawMaterialName:
                                    obj.RawMaterials[k].hasOwnProperty("Product")
                                        ? obj.RawMaterials[k].Product
                                        : "",

                                Qty:
                                    obj.RawMaterials[k].hasOwnProperty("Qty")
                                        ? obj.RawMaterials[k].Qty
                                        : "",

                                ProductID:
                                    obj.hasOwnProperty("Product") &&
                                        obj.Product &&
                                        obj.Product.hasOwnProperty("ProductID")
                                        ? obj.Product.ProductID
                                        : "",

                                RawMaterialID:
                                    obj.RawMaterials[k].hasOwnProperty("ProductID")
                                        ? obj.RawMaterials[k].ProductID
                                        : ""

                            };

                        }

                        else {

                            record = {

                                BOMName: "",

                                ProductSKU: "",

                                ProductName: "",

                                RawMaterialName:
                                    obj.RawMaterials[k].hasOwnProperty("Product")
                                        ? obj.RawMaterials[k].Product
                                        : "",

                                Qty:
                                    obj.RawMaterials[k].hasOwnProperty("Qty")
                                        ? obj.RawMaterials[k].Qty
                                        : "",

                                ProductID:
                                    obj.hasOwnProperty("Product") &&
                                        obj.Product &&
                                        obj.Product.hasOwnProperty("ProductID")
                                        ? obj.Product.ProductID
                                        : "",

                                RawMaterialID:
                                    obj.RawMaterials[k].hasOwnProperty("ProductID")
                                        ? obj.RawMaterials[k].ProductID
                                        : ""

                            };

                        }

                        exportList.push(record);

                    }

                }

            }

            /* -------- EXPORT COLUMNS -------- */

            const exportColumns = [

                { header: "BOM Name", field: "BOMName" },

                { header: "Product SKU", field: "ProductSKU" },

                { header: "Product Name", field: "ProductName" },

                { header: "Raw Material", field: "RawMaterialName" },

                { header: "Qty", field: "Qty" }

            ];

            if (exportList.length > 0) {

                await exportFile({

                    data: exportList,

                    columns: exportColumns,

                    fileType: type,

                    title: "BOM",

                    landscape: true

                });

            }

            else {

                this.setState({

                    showExportMessage: true,
                    exportMessage: "No data available to export"

                });

            }

            this.setState({

                showOption: false

            });

        }

        catch (err) {

            console.error("Export error", err);

            this.setState({

                showExportMessage: true,
                exportMessage: "Export failed"

            });

        }

    };

    /* ------------------ IMPORT ------------------ */

    onImport = () => {

        this.setState({

            showImport: true,
            showOption: false

        });

    };

    onImportLog = () => {

        this.setState({

            showImportLog: true,
            showOption: false

        });

    };

    /* ------------------ PAGINATION ------------------ */

    onNextClick = () => {

        this.setState(

            prev => ({ page: prev.page + 1 }),

            this.loadData

        );

    };

    onPreviousClick = () => {

        if (this.state.page > 1)

            this.setState(

                prev => ({ page: prev.page - 1 }),

                this.loadData

            );

    };

    onRecordsPerPageCountChange = (size) => {

        this.setState({

            pageSize: Number(size),
            page: 1

        }, this.loadData);

    };

    /* ------------------ RENDER ------------------ */

    onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

    render() {

        return (

            <>

                <ListingPage
                      {...this.props} 
                      onPageChange={this.onPageChange}
                    listPageSettings={{

                        ...this.state.listPageSettings,

                        Search: {

                            ...this.state.listPageSettings.Search,

                            isFilterActive:
                                this.state.isFilterActive

                        }

                    }}

                    list={this.state.list}

                    loading={this.state.loading}

                    totalItemsCount={this.state.totalCount}

                    recordFrom={
                        (this.state.page - 1)
                        *
                        this.state.pageSize

                    }

                    itemsCountPerPage={
                        this.state.pageSize

                    }

                    onNextClick={this.onNextClick}

                    onPreviousClick={
                        this.onPreviousClick

                    }

                    onRecordsPerPageCountChange={
                        this.onRecordsPerPageCountChange

                    }

                    onHeaderButtonClicked={
                        this.onHeaderButtonClicked

                    }

                    onRowButtonClicked={
                        this.onRowButtonClicked

                    }

                />

                {/* ADD EDIT */}

                {this.state.showAddBOM && (

                    <AddEditBOM

                        {...this.props}

                        selectedRecord={
                            this.state.selectedRow

                        }

                        onClose={() =>
                            this.setState({
                                showAddBOM: false
                            })
                        }

                        onSave={() =>
                        {
                              this.setState({
                                showAddBOM: false
                            })
                            this.loadData()
                        }
                            
                        }

                    />

                )}

                {/* FILTER */}

                {this.state.showFilter && (
                    <Window

                        header="Filter"

                        size="small"
   slide={true}


                        onClose={() =>

                            this.setState({
                                showFilter: false
                            })

                        }

                        onButtonClick={(action) => {

                            if (
                                action.toLowerCase() === "apply"
                            ) {

                                this.onApplyFilter();

                            }

                            else if (
                                action.toLowerCase() === "clear"
                            ) {

                                this.onClearFilter();

                            }

                        }}

                        buttons={[
                            {
                                Type: "secondary",
                                Text: "Clear",
                                Align: "left"
                            },
                            {
                                Type: "primary",
                                Text: "Apply",
                                Align: "right"
                            }
                        ]}

                    >


                        <Input
                            type="text"

                            label="Product"

                            value={
                                this.state.filter.product
                            }

                            onChange={(v) =>

                                this.setState({

                                    filter: {

                                        ...this.state.filter,

                                        product: v

                                    }

                                })

                            }

                        />

                        <Input
                            type="text"
                            label="SKU"

                            value={
                                this.state.filter.sku
                            }

                            onChange={(v) =>

                                this.setState({

                                    filter: {

                                        ...this.state.filter,

                                        sku: v

                                    }

                                })

                            }

                        />

                        <Input

                            type="select"

                            label="Status"

                            value={
                                this.state.filter.status
                            }

                            onChange={(v) =>

                                this.setState({

                                    filter: {

                                        ...this.state.filter,

                                        status: v

                                    }

                                })

                            }

                        >

                            <option value="active">
                                Active
                            </option>

                            <option value="inactive">
                                Inactive
                            </option>

                            <option value="all">
                                All
                            </option>

                        </Input>

                    </Window>

                )}

                {/* OPTIONS */}

                {this.state.showOption && (

                   <Window

                        header="Option" choiceList
                        slide={true}
                        size="small"
                        onClose={() =>

                            this.setState({
                                showOption: false
                            })

                        }

                      

                    >

                      <div
  style={{
    display: "flex",
    flexDirection: "column", // 👈 makes items stack vertically
    gap: 10,
    justifyContent: "center"
  }}
>

                            <ExportButton

                                onExport={
                                    this.handleExport
                                }

                                loading={
                                    this.state.loading
                                }

                            />

                            <Button

                                type="secondary"

                                text="Import"

                                onClick={
                                    this.onImport
                                }

                            />

                            <Button

                                type="secondary"

                                text="Import Log"

                                onClick={
                                    this.onImportLog
                                }

                            />

</div>
                    </Window>

                )}

                {/* DELETE */}

                {this.state.showDelete && (

                    <Window

                        header="Delete"
                        modal
                        onClose={() =>
                            this.setState({
                                showDelete: false
                            })
                        }

                        onButtonClick={(type) => {

                            if (
                                type.toLowerCase() === "yes"
                            )
                                this.deleteRecord();

                            else

                                this.setState({
                                    showDelete: false
                                });

                        }}

                        buttons={[
                               {
                Type: "secondary",
                Text: "No",
                Align: "left"
              },
              {
                Type: "primary",
                Text: "Yes",
                Align: "right"
              }

                        ]}

                    >

                        Are you sure to delete?

                    </Window>

                )}

                {/* IMPORT */}

                {this.state.showImport && (

                    <ImportData

                        {...this.props}

                        importType="bom"
                        slide={true}
                        onClose={() =>
                            this.setState({
                                showImport: false
                            })
                        }

                        onImportCompleted={() =>
                            this.loadData()
                        }

                    />

                )}

                {/* IMPORT LOG */}

                {this.state.showImportLog && (

                    <ImportLog

                        {...this.props}

                        importType="bom"
                        slide={true}

                        onClose={() =>
                            this.setState({
                                showImportLog: false
                            })
                        }

                    />

                )}

            </>

        );

    }

}

export default BomList;